import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { style: {"display":"flex"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_List = _resolveComponent("List")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isEdit)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.$style.title)
        }, [
          _createElementVNode("label", null, _toDisplayString(_ctx.title) + ": ", 1)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.isEdit)
      ? (_openBlock(), _createBlock(_component_a_upload, {
          key: 1,
          multiple: "",
          ref: "uploadRef",
          name: _ctx.name,
          "file-list": _ctx.fileList,
          "onUpdate:file-list": _cache[0] || (_cache[0] = ($event: any) => (_ctx.fileList = $event)),
          customRequest: _ctx.ossRequest,
          showUploadList: false,
          "before-upload": _ctx.handleBeforeUpload,
          onChange: _ctx.handleChange,
          accept: _ctx.type
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.$style.title)
              }, [
                _createElementVNode("label", null, _toDisplayString(_ctx.title) + ": ", 1)
              ], 2),
              (_ctx.isEdit)
                ? _renderSlot(_ctx.$slots, "default", { key: 0 }, () => [
                    _createVNode(_component_a_button, {
                      class: _normalizeClass(_ctx.$style.btn),
                      disabled: _ctx.fileList.length >= _ctx.maxlength,
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.upload.template')), 1)
                      ]),
                      _: 1
                    }, 8, ["class", "disabled"])
                  ])
                : _createCommentVNode("", true)
            ])
          ]),
          _: 3
        }, 8, ["name", "file-list", "customRequest", "before-upload", "onChange", "accept"]))
      : _createCommentVNode("", true),
    (_ctx.showList)
      ? (_openBlock(), _createBlock(_component_List, _mergeProps({
          key: 2,
          "file-list": _ctx.fileList,
          "onUpdate:file-list": _cache[1] || (_cache[1] = ($event: any) => (_ctx.fileList = $event)),
          isEdit: _ctx.isEdit
        }, _ctx.$attrs, {
          onHandleManualRemove: _ctx.uploadRef?.handleManualRemove,
          onHandleRemove: _ctx.uploadRef?.handleRemove
        }), null, 16, ["file-list", "isEdit", "onHandleManualRemove", "onHandleRemove"]))
      : _createCommentVNode("", true)
  ]))
}